import { HttpResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit } from '@angular/core';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'fury-view-email-template',
  templateUrl: './view-email-template.component.html',
  styleUrls: ['./view-email-template.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class ViewEmailTemplateComponent implements OnInit {

  emailTemplateData!:any;
  isLoading : boolean = true;
  constructor(
    private apiService: ApiService,
  ) { }

  ngOnInit(): void {
    this.getEmailTemplate();
  }
  getEmailTemplate(){
    this.isLoading = true;
    this.apiService.get('admin/email-template-content/get-email-template-content').subscribe((res: HttpResponse<any>)=>{
      if(res.body){
        this.isLoading = false;
        this.emailTemplateData = res?.body?.emailTemplateContent;
        this.emailTemplateData.aboveImageText = JSON.parse(res?.body?.emailTemplateContent.aboveImageText);
        this.emailTemplateData.belowImageText = JSON.parse(res?.body?.emailTemplateContent.belowImageText);
        this.emailTemplateData.bottomText = JSON.parse(res?.body?.emailTemplateContent.bottomText);
        this.emailTemplateData.senderName = res?.body?.emailTemplateContent?.senderName;
        this.emailTemplateData.sentEmailFrom  = res?.body?.emailTemplateContent?.sentEmailFrom;
        this.emailTemplateData.replyToAddress  = res?.body?.emailTemplateContent?.replyToAddress;
      }
    }, err =>{
      if(err){
        this.isLoading = false;
        this.apiService.alert(ErrorText.SomeThingWentWrong, ErrorType.Error);
      }
    })
  }

}
